import { render, staticRenderFns } from "./menuSelect.vue?vue&type=template&id=94b04ffa&scoped=true"
import script from "./menuSelect.vue?vue&type=script&lang=js"
export * from "./menuSelect.vue?vue&type=script&lang=js"
import style0 from "./menuSelect.vue?vue&type=style&index=0&id=94b04ffa&prod&lang=less&scoped=true"
import style1 from "./menuSelect.vue?vue&type=style&index=1&id=94b04ffa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b04ffa",
  null
  
)

export default component.exports